(() => {
  const awSetData = (node, key, value) => { if (node.dataset[key] !== value) node.dataset[key] = value; };
  const awSetBool = (node, key, value) => { if (node[key] !== value) node[key] = value; };
  const awSetText = (node, value) => { if (node.textContent !== value) node.textContent = value; };

  if (window.__awExactModelGateLoaded) return;
  window.__awExactModelGateLoaded = true;

  const norm = (v = '') => String(v).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const split = (v = '') => String(v).split(',').map(norm).filter(Boolean);

  const lockCard = (card, badgeText, conflict = false) => {
    const box = card.querySelector('[data-aw-product-checkbox]');
    const selector = box?.closest('.aw-compatible-card__selector');
    const quick = card.querySelector('[data-aw-quick-add]');
    const badge = card.querySelector('[data-aw-card-badge]');
    awSetData(card, 'awEligible', 'false');
    if (conflict) awSetData(card, 'awTechnicalConflict', 'true');
    if (box) { awSetBool(box, 'checked', false); awSetBool(box, 'disabled', true); }
    if (selector) awSetBool(selector, 'hidden', true);
    if (quick) { awSetBool(quick, 'disabled', true); awSetBool(quick, 'hidden', true); }
    if (badge) awSetText(badge, badgeText);
  };

  const rootsIn = (scope = document) => {
    const roots = [];
    if (scope?.matches?.('[data-aw-compatible-products]')) roots.push(scope);
    scope?.querySelectorAll?.('[data-aw-compatible-products]').forEach((root) => roots.push(root));
    return roots;
  };

  const apply = (scope = document) => {
    rootsIn(scope).forEach((root) => {
      const current = new Set(split(root.dataset.currentModels || ''));
      if (!current.size) return;

      root.querySelectorAll('[data-aw-product-card]').forEach((card) => {
        const relationModels = split(card.dataset.awRelationModels || '');

        if (!relationModels.length) {
          awSetData(card, 'awExactModelProof', 'missing');
          awSetData(card, 'awExactModelUnproven', 'true');
          lockCard(card, 'À vérifier — aucune preuve pour le modèle exact sélectionné');
          return;
        }

        const overlap = relationModels.some((handle) => current.has(handle));
        if (overlap) {
          awSetData(card, 'awExactModelProof', 'matched');
          awSetData(card, 'awExactModelUnproven', 'false');
          return;
        }

        awSetData(card, 'awExactModelProof', 'mismatch');
        awSetData(card, 'awExactModelUnproven', 'false');
        lockCard(card, 'Incompatible avec le modèle exact sélectionné', true);
      });
    });
  };

  document.addEventListener('click', (event) => {
    const action = event.target.closest?.('[data-aw-quick-add], [data-aw-product-checkbox]');
    const card = action?.closest?.('[data-aw-product-card]');
    if (card?.dataset.awTechnicalConflict === 'true' || card?.dataset.awExactModelUnproven === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const pendingRoots = new Set();
  let scheduledFrame = 0;
  const scheduleRoot = (root) => {
    if (!root) return;
    pendingRoots.add(root);
    if (scheduledFrame) return;
    scheduledFrame = requestAnimationFrame(() => {
      scheduledFrame = 0;
      const roots = [...pendingRoots];
      pendingRoots.clear();
      roots.forEach((item) => apply(item));
    });
  };
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (!mutation.addedNodes?.length) return;
      // Badge copy is an output of these guards, never a compatibility input.
      if (mutation.target?.closest?.('[data-aw-card-badge]')) return;
      const root = mutation.target?.closest?.('[data-aw-compatible-products]');
      if (root) scheduleRoot(root);
    });
  });
  const observedRoots = new WeakSet();
  const observeRoots = (scope = document) => {
    const roots = [];
    if (scope?.matches?.('[data-aw-compatible-products]')) roots.push(scope);
    scope?.querySelectorAll?.('[data-aw-compatible-products]').forEach((root) => roots.push(root));
    roots.forEach((root) => {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
      observer.observe(root, { childList: true, subtree: true });
    });
  };

  const start = () => {
    apply(document);
    observeRoots(document);
  };

  document.addEventListener('shopify:section:load', (event) => {
    apply(event.target);
    observeRoots(event.target);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();